import type { ShellTranslate } from '@/lib/shell/use-shell-translation'
import { APP_BRAND_THEME, APP_CUSTOM_THEME, APP_THEME_META, type AppThemeChoice } from './app-themes'

/**
 * What the Theme menu says about a theme, in the interface language (shell.theme.app.* in
 * messages/shell/<locale>.json).
 *
 * The five ready-made themes are names — Classic, Ledger, Sentinel, Harbor, Clarity — and are written
 * the same in every language, as the admin console writes them. Custom and Your brand are words, and are translated.
 * What each theme is for is translated; its English is the metadata in app-themes.ts, which
 * components/app-theme/__tests__/app-theme-menu-language.spec.tsx holds equal to the English catalogue.
 */
export function appThemeName(choice: AppThemeChoice, t: ShellTranslate): string {
  if (choice === APP_CUSTOM_THEME) return t('shell.theme.app.custom')
  return choice === APP_BRAND_THEME ? t('shell.theme.app.yourBrand') : APP_THEME_META[choice].label
}

/** One line on what the theme is for. */
export function appThemeDescription(choice: AppThemeChoice, t: ShellTranslate): string {
  return t(`shell.theme.app.description.${choice}`)
}
